import { graphql } from "relay-runtime"

const FamilyHistoryFragment = graphql`
  fragment FamilyHistoryFragment on FamilyHistory {
    id
    autoimmuneDisease
    cancer
    heartDisease
    diabetes
    comment
  }
`

export { FamilyHistoryFragment }
